var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { colors, cssThemedValue, cssVarsThemed } from '@creditornot/cb-ingredients';
import { createCssVars } from '@creditornot/cb-utils';
import responsiveContainerMixin from './responsiveContainerMixin';
var colorCssVars = createCssVars(['background']);
var Root = styled.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  min-height: 76px;\n  border-top: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n"], ["\n  ", "\n\n  ", "\n\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  min-height: 76px;\n  border-top: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n"])), responsiveContainerMixin, cssVarsThemed({
    background: {
        light: colors.salt100,
        dark: 'transparent',
    },
}), cssThemedValue('borderPrimary'), colorCssVars.background, cssThemedValue('textPrimary'), function (_a) {
    var roundedCorners = _a.roundedCorners;
    return (roundedCorners ? 8 : 0);
}, function (_a) {
    var roundedCorners = _a.roundedCorners;
    return (roundedCorners ? 8 : 0);
});
var ModalFooter = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.roundedCorners, roundedCorners = _b === void 0 ? true : _b, style = _a.style;
    return (React.createElement(Root, { className: className, roundedCorners: roundedCorners, style: style }, children));
};
export default ModalFooter;
var templateObject_1;
//# sourceMappingURL=ModalFooter.js.map